import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { captureAttribution } from './lib/attribution'
import { captureVariant } from './lib/variant'
import { trackMetaViewContent } from './lib/analytics'
import { initEnrollment } from './lib/enrollment'
import { useOnboardingStore } from './store/onboardingStore'

async function boot() {
  // index.html decides QA vs production analytics before initialising GA4 /
  // Google Ads / the Meta pixel. Without ?qa= this promise is already resolved
  // (analytics initialised synchronously, as before); with ?qa= it waits for
  // the verifyQaToken callable so no event can fire before that decision.
  try {
    await window.kpAnalyticsReady
  } catch {
    // never rejects; defensive
  }

  // Capture gclid / fbclid / UTM params on first page load
  captureAttribution()

  // Capture funnel variant from ?ref= / ?variant= (used to swap Meta-compliant copy).
  // Persisted in localStorage so deeper steps keep the right copy on refresh.
  captureVariant()

  // Reset a saved step index that belongs to a different step list (plan §A4).
  useOnboardingStore.getState().syncStepsVersion()

  // First-landing enrollment record (written once per browser, never overwritten).
  initEnrollment()

  // Meta Pixel fires PageView automatically from index.html.
  // ViewContent is our top-of-funnel signal for optimization.
  trackMetaViewContent()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

void boot()
